<script lang="ts">
  import RepositoryFactory, { CONTRACT, DATA_CHARGE } from '../../repositories/RepositoryFactory';
  import { loginUser } from '../../components/auth/LoginUser';
  import Loading from '../loader.svelte';
  import type { GetContractResult } from '../../repositories/contract';
  import { getContext } from 'svelte';
  import { isTheBeginningOfTheEndOfTheMonth } from '../../components/Util.svelte';

  const { close }: any = getContext('simple-modal');
  const dataChargeCapacityGroup = [
    { code: '100M', name: '100M：330円（税込み）' },
    { code: '500M', name: '500M：550円（税込み）' },
    { code: '1G', name: '1G：880円（税込み）' }
  ];

  let contract: GetContractResult;
  let isComplete = false;
  let isInput = true;
  let promise = getApi();
  let chargeCapacitySelected: '' | '100M' | '500M' | '1G' = '';
  let disabledCharge = false;
  let disabledChargeForStatus = false;

  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    return contractRepository
      .getContract()
      .then((res) => {
        contract = res;
        if (contract.isUnlimited) {
          disabledCharge = true;
        } else if (
          (contract.contractStatusCode === 'SUSPEND' && contract.suspendReasonCode !== 'APPLIED') ||
          contract.contractStatusCode === 'TERMINATED'
        ) {
          disabledChargeForStatus = true;
        }
        return res;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生しました。');
        }
        throw new Error();
      });
  }

  function onConfirm() {
    if (isTheBeginningOfTheEndOfTheMonth()) {
      alert('毎月、月末23時～月初2時はデータチャージはできません。');
      return;
    }

    if (!chargeCapacitySelected) {
      alert('データチャージ容量を選択してください。');
      return;
    }
    isInput = false;
  }

  function doRegister() {
    if (isTheBeginningOfTheEndOfTheMonth()) {
      alert('毎月、月末23時～月初2時はデータチャージはできません。');
      return;
    }
    const dataChargeRepository = RepositoryFactory[DATA_CHARGE];
    dataChargeRepository
      .dataCharge({ chargeCapacity: chargeCapacitySelected })
      .then((res) => {
        isInput = false;
        isComplete = true;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('データチャージに失敗しました。');
        }
        throw new Error();
      });
  }
  function onBack() {
    isComplete = false;
    isInput = true;
  }
  function closeModal() {
    if (isComplete) {
      location.reload();
    } else {
      close();
    }
  }
</script>

<div class="h-auto p-8 bg-white w-full m-auto">
  <div class="flex justify-between mb-6">
    <div class=" text-gray-700">
      <h1 class="text-2xl font-bold">データチャージ</h1>
    </div>
  </div>

  {#if isInput}
    {#await promise}
      <Loading />
    {:then contract}
      <div class="shadow rounded bg-gray-50 border-t-4 border-green-400">
        <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
          <div class="flex flex-col">
            <div class="flex-1 mb-10">
              <div class="inline-grid grid-cols-1 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-1 justify-self-start w-full">
                  {#if disabledChargeForStatus}
                    <div class="mb-4">チャージできる契約状態ではありません。</div>
                  {:else if disabledCharge}
                    <div class="mb-4">チャージ対象プランではありません。</div>
                  {/if}
                  <div class="grid grid-cols-1">
                    <label class="grid-1 items-center">
                      <input
                        type="radio"
                        name="chargeCapacity"
                        value="100M"
                        bind:group={chargeCapacitySelected}
                        checked={chargeCapacitySelected === '100M'}
                        required
                      />
                      <span>{dataChargeCapacityGroup.find((v) => v.code === '100M').name}</span>
                    </label>
                    <label class="grid-1 items-center">
                      <input
                        type="radio"
                        name="chargeCapacity"
                        value="500M"
                        bind:group={chargeCapacitySelected}
                        checked={chargeCapacitySelected === '500M'}
                        required
                      />
                      <span>{dataChargeCapacityGroup.find((v) => v.code === '500M').name}</span>
                    </label>
                    <label class="grid-1 items-center">
                      <input
                        type="radio"
                        name="chargeCapacity"
                        value="1G"
                        bind:group={chargeCapacitySelected}
                        checked={chargeCapacitySelected === '1G'}
                        required
                      />
                      <span>{dataChargeCapacityGroup.find((v) => v.code === '1G').name}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col justify-items-center items-center">
              <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
                <button class="button-secondary mb-5" on:click={() => closeModal()}>閉じる</button>
                <button
                  class="button-primary md:ml-5 mb-5"
                  disabled={disabledCharge || disabledChargeForStatus}
                  on:click={() => onConfirm()}
                >
                  チャージ
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    {/await}
  {:else}
    <div class="shadow rounded bg-gray-50 border-t-4 border-green-400">
      <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
        <div class="flex flex-col">
          {#if isComplete}
            <div class="flex-1 mb-10">
              <div class="inline-grid grid-cols-1 justify-items-center items-center min-w-full p-4">
                <div class="inline-flex justify-items-center text-center min-w-full">
                  <span>チャージ完了しました。</span>
                </div>
              </div>
            </div>
            <div class="flex flex-col justify-items-center items-center">
              <div class="flex-1">
                <button class="button-secondary" on:click={() => closeModal()}>閉じる</button>
              </div>
            </div>
          {:else}
            <div class="flex-1 mb-10">
              <div class="inline-grid grid-cols-1 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-1 justify-self-start w-full">
                  <div class="grid grid-cols-1 mb-2">
                    <span>{dataChargeCapacityGroup.find((v) => v.code === chargeCapacitySelected).name}</span>
                    <span>チャージします。</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col justify-items-center items-center">
              <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
                <button class="button-secondary mb-5" on:click={() => onBack()}>戻る</button>
                <button
                  class="button-primary md:ml-5 mb-5"
                  disabled={disabledCharge}
                  on:click|once={() => doRegister()}
                >
                  実行
                </button>
              </div>
            </div>
          {/if}
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-14 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
  .button-secondary {
    @apply bg-gray-300 rounded hover:bg-green-500 text-gray-500 text-sm font-semibold focus:outline-none px-14 py-2;
  }
</style>
